import _ from 'lodash';

export const capitalizeWords = (sentence) => {
    return sentence ? _.startCase(sentence) : null;
};

export const generateCode = (value) => {
    if (!value) return '';
    // Split the value into an array of words
    // const words = value?.split(' ');
    // Capitalize the first letter of each word and join them without spaces
    // return words?.map((word) => word.toLowerCase() + word.slice(1)).join('');
    return value.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
};

export const generateUnderscoreCode = (value) => {
    return value ? value?.replace(/\s+/g, '_')?.toLowerCase() : null;
};

export const joinNamesAndCapitalize = (arrList) => {
    return arrList.map((item) => {
        return {
            ...item,
            fullname: item.name.charAt(0).toUpperCase() + item.name.slice(1) + ' ' + item.surname.charAt(0).toUpperCase() + item.surname.slice(1),
        };
    });
};

export const isAlphaNumOnly = (dataValue) => {
    // Use a regular expression to check if the input contains only alphanumeric characters and underscores
    const regex = /^[a-zA-Z0-9_]+$/;

    // Test the input against the regular expression
    return regex.test(dataValue);
};

export const generateUniqueKey = () => {
    const timestamp = new Date().getTime(); // Get current timestamp
    const random = Math.floor(Math.random() * 1000000); // Generate a random number

    // Combine timestamp and random number to create a unique key
    const uniqueKey = `${timestamp}${random}`;

    return uniqueKey;
};
